function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 34.7143,
  r: 34.2857,
  fill: "url(#paint0_radial)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 34.7143,
  r: 34.2857,
  fill: "url(#paint1_linear)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 34.7143,
  r: 33.2857,
  stroke: "#D67504",
  strokeOpacity: 0.27,
  strokeWidth: 2
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_d)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "path-3-outside-1",
  maskUnits: "userSpaceOnUse",
  x: 6.57143,
  y: 32.5714,
  width: 13,
  height: 18,
  fill: "black"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "white",
  x: 6.57143,
  y: 32.5714,
  width: 13,
  height: 18
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.10376 41.6626L11.5558 35.9411C12.1 34.6714 13.9 34.6714 14.4442 35.9411L16.8962 41.6626C18.095 44.4598 16.0432 47.5714 13 47.5714C9.95677 47.5714 7.90498 44.4598 9.10376 41.6626Z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M9.10376 41.6626L11.5558 35.9411C12.1 34.6714 13.9 34.6714 14.4442 35.9411L16.8962 41.6626C18.095 44.4598 16.0432 47.5714 13 47.5714C9.95677 47.5714 7.90498 44.4598 9.10376 41.6626Z",
  fill: "#6CDCFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.5558 35.9411L13.5254 36.7852V36.7852L11.5558 35.9411ZM9.10376 41.6626L7.13417 40.8185H7.13417L9.10376 41.6626ZM16.8962 41.6626L18.8658 40.8185L18.8658 40.8185L16.8962 41.6626ZM14.4442 35.9411L12.4746 36.7852V36.7852L14.4442 35.9411ZM9.58624 35.097L7.13417 40.8185L11.0734 42.5068L13.5254 36.7852L9.58624 35.097ZM18.8658 40.8185L16.4138 35.097L12.4746 36.7852L14.9266 42.5068L18.8658 40.8185ZM13 49.7143C17.5816 49.7143 20.6706 45.0297 18.8658 40.8185L14.9266 42.5068C15.5194 43.8899 14.5048 45.4286 13 45.4286V49.7143ZM7.13417 40.8185C5.32938 45.0297 8.41838 49.7143 13 49.7143V45.4286C11.4952 45.4286 10.4806 43.8899 11.0734 42.5068L7.13417 40.8185ZM13.5254 36.7852C13.3275 37.2472 12.6725 37.2472 12.4746 36.7852L16.4138 35.097C15.1275 32.0957 10.8725 32.0957 9.58624 35.097L13.5254 36.7852Z",
  fill: "#0084C0",
  fillOpacity: 0.42,
  mask: "url(#path-3-outside-1)"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_di)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25 25C25 23.8954 25.8954 23 27 23H34C35.1046 23 36 23.8954 36 25V25C36 26.1046 35.1046 27 34 27H27C25.8954 27 25 26.1046 25 25V25Z",
  fill: "#793021"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter3_di)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M51 25C51 23.8954 51.8954 23 53 23H60C61.1046 23 62 23.8954 62 25V25C62 26.1046 61.1046 27 60 27H53C51.8954 27 51 26.1046 51 25V25Z",
  fill: "#793021"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter4_di)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M33 50C33 48.8954 33.8954 48 35 48H52C53.1046 48 54 48.8954 54 50V50C54 51.1046 53.1046 52 52 52H35C33.8954 52 33 51.1046 33 50V50Z",
  fill: "#EB5D3E"
}));

var _ref7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d",
  x: 0.142859,
  y: 0.428581,
  width: 85.7143,
  height: 85.7143,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8.57143
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4.28571
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.9 0 0 0 0 0.6165 0 0 0 0 0.19125 0 0 0 0.33 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d",
  x: 2.32558,
  y: 30.7031,
  width: 21.3488,
  height: 25.4397,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2.14286
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.14286
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.200764 0 0 0 0 0.343468 0 0 0 0 0.408333 0 0 0 0.38 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_di",
  x: 22.86,
  y: 22.86,
  width: 15.28,
  height: 8.28,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.07
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2.14
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.095
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect2_innerShadow"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter3_di",
  x: 48.86,
  y: 22.86,
  width: 15.28,
  height: 8.28,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.07
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2.14
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.095
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect2_innerShadow"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter4_di",
  x: 30.86,
  y: 47.86,
  width: 25.28,
  height: 8.28,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.07
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2.14
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.095
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect2_innerShadow"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(43 0.428581) rotate(90) scale(68.5714)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EED919"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F1BE08"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 43,
  y1: 0.428581,
  x2: 43,
  y2: 69,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.52
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})));

function SvgErrosLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 87,
    viewBox: "0 0 86 87",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrosLogo);
export default __webpack_public_path__ + "static/media/erros-logo.952aafad.svg";
export { ForwardRef as ReactComponent };